import React, { Component } from "react";
import Nprogress from "nprogress";

import CircularProgress from "components/atoms/CircularProgress/index";

import "nprogress/nprogress.css";
import "react-placeholder/lib/reactPlaceholder.css";

export default function asyncComponent(importComponent) {
	class AsyncFunc extends Component {
		_isMounted = false;

		constructor(props) {
			super(props);
			this.state = {
				component: null,
			};
		}

		componentDidMount() {
			this._isMounted = true;
			Nprogress.start();

			importComponent().then(({ default: Component }) => {
				if (this._isMounted) {
					this.setState({
						component: <Component {...this.props} />,
					});
				}
				Nprogress.done();
			});
		}

		componentWillUnmount() {
			this._isMounted = false;
		}

		render() {
			const Component = this.state.component || (
				<div className="loader-view" style={{ height: "calc(100vh - 200px)" }}>
					<CircularProgress />
				</div>
			);
			return Component;
		}
	}

	return AsyncFunc;
}
